import rawRequest from "../rawRequest";
import { useQuery, useMutation } from "@tanstack/react-query";

/**
 * Fetch MongoDB collections.
 */
export const useCollections = (env) =>
	useQuery({
		queryKey: ["collections", env],
		queryFn: async () => {
			const response = await rawRequest({
				url: `${env}/collections`,
				method: "GET",
			});

			return response.data.collections || [];
		},
		enabled: false, // Disable automatic fetching
		retry: 0, // Retry fetching on failure
		initialData: [], // Start with an empty array
	});

export const useValidateSchemaMutation = () => {
	return useMutation({
		mutationKey: "validate-schema",
		mutationFn: async ({ schema, collectionName, env }) => {
			const response = await rawRequest({
				url: `${env}/validate-schema`,
				method: "POST",
				data: { schema, collectionName },
			});

			if (!response.data) {
				throw new Error("Validation response is empty");
			}

			return response.data;
		},
		onSuccess: (data) => {
			return data;
		},
	});
};
